<script setup>
import { Analytics } from '@vercel/analytics/vue';
import { onMounted } from 'vue';
import { supabase } from './supabase';
import posthog from 'posthog-js';

onMounted(async () => {
  const { data: { session } } = await supabase.auth.getSession();
  if (session?.user) {
    posthog.identify(session.user.id, { email: session.user.email });
  }
});
</script>

<template>
    <Analytics />
    <router-view />
</template>

<style scoped></style>